var resources = require('items-view-strings');
    var strings = resources['_D1mLoLcAWrlhB6Z+0gda5w'];
export { strings };
export default strings;
